
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.94 13.06a1.5 1.5 0 010-2.12l9.545-9.547a1.5 1.5 0 112.122 2.122L4.12 12l8.486 8.485a1.5 1.5 0 11-2.122 2.122L.94 13.06zm3.296.44H2v-3h2.236v3z","fill":"#A3A3A3"}})])
          )
        }
      }
    